import { ORGANIZATION_DISPLAY_NAME } from '../config/branding';

const DEFAULT_HERO_IMAGE =
  'https://images.unsplash.com/photo-1576267423048-15c0040fec78?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGNvbGxhYm9yYXRpb24lMjB0ZWFtd29ya3xlbnwwfHx8fDE3NjUzOTY4Nzl8MA&ixlib=rb-4.1.0&q=85';

export const DEFAULT_LOGIN_HERO_IMAGE = DEFAULT_HERO_IMAGE;

/**
 * Normalise la réponse `/v1/iam/login-hint` pour l'écran de connexion web.
 */
export function normalizeLoginBrandingFromHint(data, t) {
  const raw = data?.login_branding;
  if (!raw || typeof raw !== 'object') {
    return null;
  }

  const orgName =
    String(raw.organization_name || data?.organization_name || '').trim() ||
    ORGANIZATION_DISPLAY_NAME;

  return {
    organizationName: orgName,
    logoUrl: String(raw.logo_url || '').trim(),
    heroImageUrl: String(raw.hero_image_url || '').trim() || DEFAULT_HERO_IMAGE,
    heroKicker: String(raw.hero_kicker || '').trim() || t('loginWeb.heroKicker'),
    heroTitle: String(raw.hero_title || '').trim() || t('loginWeb.heroTitle'),
    heroSubtitle: String(raw.hero_subtitle || '').trim() || t('loginWeb.heroSubtitle'),
    feature1Title:
      String(raw.feature_1_title || '').trim() || t('loginWeb.featureMembersTitle'),
    feature1Desc:
      String(raw.feature_1_desc || '').trim() || t('loginWeb.featureMembersDesc'),
    feature2Title:
      String(raw.feature_2_title || '').trim() || t('loginWeb.featureSecureTitle'),
    feature2Desc:
      String(raw.feature_2_desc || '').trim() || t('loginWeb.featureSecureDesc'),
  };
}

export function resolveLoginBrandingDisplay(branding, t) {
  if (!branding) {
    return {
      organizationName: ORGANIZATION_DISPLAY_NAME,
      logoUrl: '',
      heroImageUrl: DEFAULT_HERO_IMAGE,
      heroKicker: t('loginWeb.heroKicker'),
      heroTitle: t('loginWeb.heroTitle'),
      heroSubtitle: t('loginWeb.heroSubtitle'),
      feature1Title: t('loginWeb.featureMembersTitle'),
      feature1Desc: t('loginWeb.featureMembersDesc'),
      feature2Title: t('loginWeb.featureSecureTitle'),
      feature2Desc: t('loginWeb.featureSecureDesc'),
    };
  }
  return branding;
}
